import { CONFIG_AUTHORIZATION_CONNECT_PARTNER } from "../constant";

const roles = {
  ADMIN: 'ROLE_ADMIN',
  SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
  STOCKER: 'ROLE_STOCKER',
  ACCOUNTANT: 'ROLE_ACCOUNTANT',
};

export default {
  roles: roles,
  authenSuccesUrlRedirect: function (hasAuthor) {
    return '/dashboard.html'
  },

  authorizationMapper: [
    {
      regex: /^\/dashboard.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.SUPER_ADMIN) || hasAuthor(roles.STOCKER) || hasAuthor(roles.ACCOUNTANT);
      }
    },
    {
      regex: /^\/administrator\/organization.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.SUPER_ADMIN);
      }
    },
    {
      regex: /^\/user-management\/managed-users.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.SUPER_ADMIN) || hasAuthor(roles.SUPER_ADMIN);
      }
    },
    {
      regex: /^\/administrator\/thread.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.SUPER_ADMIN);
      }
    },
    {
      regex: /^\/user-management\/managed-users.html/,
      isAuthorized: function () {
        return !CONFIG_AUTHORIZATION_CONNECT_PARTNER;
      }
    },
    {
      regex: /^\/user\/reset-password.html/,
      isAuthorized: function () {
        return !CONFIG_AUTHORIZATION_CONNECT_PARTNER;
      }
    },
    {
      regex: /^\/category-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ACCOUNTANT);
      }
    },
    {
      regex: /^\/customer-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ACCOUNTANT);
      }
    },
    {
      regex: /^\/product-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ACCOUNTANT);
      }
    },
    {
      regex: /^\/warehouse-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ACCOUNTANT);
      }
    },
    {
      regex: /^\/uom-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ACCOUNTANT);
      }
    },
    {
      regex: /^\/stock-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ACCOUNTANT) || hasAuthor(roles.STOCKER);
      }
    },
    {
      regex: /^\/accounting-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ACCOUNTANT);
      }
    }
  ]
}
